import { useReducer, Dispatch } from 'react'
import type { EventData, FormMetadata, FormOnDismiss, FormOnValidate, FormType, FormHideActions, AdvertiserInfo, FeedbackContext, SubmissionInfo } from './Types'

type reducerAction =
  | {
      type: 'open'
      eventDetail: EventData
      formMetadata: FormMetadata
      formType: undefined | FormType
      formHideActions: undefined | FormHideActions
      formPopperOffset: undefined | [number, number]
      formPopperPlacement: undefined | string
      formOnDismiss: undefined | FormOnDismiss
      formOnValidate: undefined | FormOnValidate
      withoutConfirmation: boolean
      advertiserInfo: undefined | AdvertiserInfo
      feedbackContext: undefined | FeedbackContext
      submissionInfo: undefined | SubmissionInfo
    }
  | { type: 'close' }

type reducerState = {
  isOpen: boolean
  eventDetail: null | EventData
  formMetadata: null | FormMetadata
  formkey: string
  formType: undefined | FormType
  formHideActions: undefined | FormHideActions
  formPopperOffset: undefined | [number, number]
  formPopperPlacement: undefined | string
  formOnDismiss: undefined | FormOnDismiss
  formOnValidate: undefined | FormOnValidate
  withoutConfirmation: undefined | boolean
  advertiserInfo: undefined | Record<string, string | number>
  feedbackContext: undefined | Record<string, string | number>
  submissionInfo: undefined | Record<string, string | number>
}

const initialState: reducerState = {
  isOpen: false,
  eventDetail: null,
  formMetadata: null,
  formkey: '0',
  formType: undefined,
  formHideActions: undefined,
  formPopperOffset: undefined,
  formPopperPlacement: undefined,
  formOnDismiss: undefined,
  formOnValidate: undefined,
  withoutConfirmation: undefined,
  advertiserInfo: undefined,
  feedbackContext: undefined,
  submissionInfo: undefined,
}

function reducer(state: reducerState, action: reducerAction) {
  switch (action.type) {
    case 'open': {
      return {
        ...state,
        isOpen: true,
        eventDetail: {
          app: action.eventDetail.app,
          page: action.eventDetail.page,
          component: action.eventDetail.component,
          instanceId: action.eventDetail.instanceId,
        },
        formMetadata: action.formMetadata,
        formkey: `${Number(state.formkey) + 1}`,
        formType: action.formType,
        formHideActions: action.formHideActions,
        formPopperOffset: action.formPopperOffset,
        formPopperPlacement: action.formPopperPlacement,
        formOnDismiss: action.formOnDismiss,
        formOnValidate: action.formOnValidate,
        withoutConfirmation: action.withoutConfirmation,
        advertiserInfo: action.advertiserInfo,
        feedbackContext: action.feedbackContext,
        submissionInfo: action.submissionInfo,
      }
    }
    case 'close': {
      return {
        ...initialState,
        formkey: state.formkey,
        isOpen: false,
      }
    }
  }
}

function useFeedbackState(): [reducerState, Dispatch<reducerAction>] {
  return useReducer(reducer, initialState)
}

export default useFeedbackState
